import { render, staticRenderFns } from "./lab-test-platform-new.vue?vue&type=template&id=86033358&"
import script from "./lab-test-platform-new.vue?vue&type=script&lang=js&"
export * from "./lab-test-platform-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports